import { Typography, Box } from '@material-ui/core'
import PlaceOutlinedIcon from '@material-ui/icons/PlaceOutlined'
import StarIcon from '@material-ui/icons/Star'
import { useState } from 'react'
import Lightbox from 'yet-another-react-lightbox'
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails'
import 'yet-another-react-lightbox/plugins/thumbnails.css'
import 'yet-another-react-lightbox/styles.css'

import NoPictureDeafault from '../../../../assets/images/NoPictureDeafault.png'
import insertPhoto from '../../../../assets/images/insertPhoto.svg'
import { lang } from '../../../../localization'
import { AccommodationInfo } from '../../../../types/cart'
import useStyles from './styles/index.styles'

type HotelCardProps = {
  hotelDetails:
    | {
        accommodationInfo: AccommodationInfo
        walletType: string
        provider: string
      }
    | undefined
}
const HotelCard = ({ hotelDetails }: HotelCardProps) => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const slides = hotelDetails?.accommodationInfo?.images?.map((img) => ({
    src: img
  })) || [{ src: '' }]

  return (
    <>
      <div className={classes.root}>
        <div className={classes.card}>
          <div className={classes.imageContainer} onClick={() => setOpen(true)}>
            <img
              src={
                hotelDetails?.accommodationInfo?.images &&
                hotelDetails?.accommodationInfo?.images?.length
                  ? hotelDetails?.accommodationInfo.images[0]
                  : NoPictureDeafault
              }
              alt="hotel"
              className={classes.image}
            />
            {slides && slides.length > 1 && (
              <div className={classes.counter}>
                <img src={insertPhoto} className={classes.photoIcon} />
                <Typography variant="h5" className={classes.iconText}>
                  {lang === 'fa'
                    ? ` ${slides.length - 1}+`
                    : ` +${slides.length - 1}`}
                </Typography>
              </div>
            )}
          </div>
          <Box className={classes.content}>
            <Box className={classes.left}>
              <div className={classes.header}>
                <Typography className={classes.title}>
                  {hotelDetails?.accommodationInfo?.name}
                </Typography>
                <Typography variant="h5" className={classes.textColor}>
                  <PlaceOutlinedIcon
                    className={classes.icon}
                    fontSize="small"
                  />
                  {hotelDetails?.accommodationInfo?.city}
                </Typography>
              </div>
              <div className={classes.payment}>
                {/* <Chip
                  size="small"
                  label={`${getTranslate('Payment Method')}: ${
                    hotelDetails?.walletType
                  }`}
                  className={classes.paymentChip}
                  variant="default"
                /> */}
                {/* <Chip
                  size="small"
                  label={`${getTranslate('Provider')}: ${
                    hotelDetails?.provider
                  }`}
                  className={classes.paymentChip}
                  variant="default"
                /> */}
              </div>
            </Box>
            <Box className={classes.right}>
              <div className={classes.stars}>
                {Array.from({
                  length: hotelDetails?.accommodationInfo?.star || 0
                }).map((_, i) => (
                  <StarIcon className={classes.icon} key={i} fontSize="small" />
                ))}
              </div>
            </Box>
          </Box>
        </div>
      </div>
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={slides}
        thumbnails={{
          position: 'bottom',
          width: 100,
          height: 100,
          imageFit: 'cover'
        }}
        plugins={[Thumbnails]}
        carousel={{
          finite: true
        }}
        styles={{
          container: {
            backgroundColor: 'black'
          }
          // slide: {
          //   maxWidth: '80vw', // optional: restrict max size
          //   maxHeight: '80vh'
          // }
        }}
      />
    </>
  )
}

export default HotelCard
